import $ from 'jquery';
import 'slick-carousel';
import 'jquery-nice-select';
import counterUp from 'counterup2'

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    if ($('.statvalue').length > 0) {
      [].forEach.call(
          document.querySelectorAll('.statvalue'),
          function (el) {
            counterUp( el, {
              duration: 2000
            } )
          }
      );
    }
    if ($('.hero-img-slider').length > 0) {

      $('.hero-text-slide, .hero-img-slider').on('init', function () {
        $('.hero-text-slide, .hero-img-slider').find('.slick-current').removeClass('slick-active').addClass('reset-animation');
        setTimeout(function () {
          $('.hero-text-slide, .hero-img-slider').find('.slick-current').removeClass('reset-animation').addClass('slick-active');
        }, 500);
      });


      jQuery('.hero-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        speed: 900,
        infinite: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        touchThreshold: 100,
        responsive: [
          {
            breakpoint: 768,
            settings: {}
          }
        ]
      });

      $('.hero-text-slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        dots: false
      });

    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js